import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
} from './Explainer';

export const SpeciesDetectedExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='species-detected-explainer'>{t('global.howDoWeMeasureThis')}</ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t('shared.ncaDetail.indicatorSpecies.speciesDetected.explainers.howDoMeasureThis.title')}
        </ExplainerTitle>
        <Stack spacing={8} className='items-start pb-6'>
          <ExplainerBody className='pb-0'>
            <ExplainerCopy
              title={t('shared.ncaDetail.indicatorSpecies.speciesDetected.explainers.howDoMeasureThis.explainerTitle')}
              body={t('shared.ncaDetail.indicatorSpecies.speciesDetected.explainers.howDoMeasureThis.explainerBody')}
            />
          </ExplainerBody>
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
